export const Actions = { "Home": 1, "Back": 2 };